<template>
    <div class="modal fade" :id="'createValueModal_'+modalId" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <form @submit.prevent="submitData" class="form">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ modalId == "createValue" ? $t('values.creation') : $t('values.modification')}}</h5>
                        <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal" aria-label="Close">
                            <span class="svg-icon svg-icon-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                                        fill="currentColor"/>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                                        fill="currentColor"/>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div class="modal-body">
                        <RequiredText />
                        <div class="d-flex flex-column mb-8 fv-row">
                            <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                                <span class="required">{{$t('values.name')}}</span>
                            </label>
                            <input type="text" v-model="formData.name" class="form-control form-control-solid" :placeholder="$t('values.name_placeholder')" required />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
                        <Button btn-class="btn-sm" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoadingValue"></Button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>

    import {ref, defineProps} from 'vue'
    import {useStore} from "vuex";
    import RequiredText from "@/components/RequiredText"
    import Button from "@/components/Button"

    const store = useStore()

    const props = defineProps({
        values: { 
            type: Object, 
            default: {
                variation: '',
                attribut_id: '',
                name: ''
            } 
        },
        id : {
            type: String,
            required: true
        },
        parent: {
            type: String,
            required: true
        },
        hasParent: {
            type: Boolean,
            required: false
        },
    })

    const modalId = ref(props.id)
    const isLoadingValue = ref(false)
    const parentId = ref(props.parent)
    const formData = ref(props.values)

    const emits = defineEmits(['load'])

    function closeModal(){
        $('#createValueModal_'+modalId.value).modal('toggle')
        if(props.hasParent){
          $('#' + parentId.value).modal('toggle')
        }
    }

    function submitData(){
        isLoadingValue.value = true
        store.dispatch('variations/updateVariation', formData.value)
            .then((response) => {
                emits('load')
                isLoadingValue.value = false
                closeModal()
                formData.value.variation = ''
                formData.value.attribut = ''
                formData.value.name = ''
                window.toastr['success'](i18n.global.t('notification.values_updated'))
            })
            .catch(err => {
                isLoadingValue.value = false
            })
    }
</script>